function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultOptions = {
  debug: false,
  logger: console
};
export var StimulusUse = /*#__PURE__*/_createClass(function StimulusUse(controller) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, StimulusUse);

  var _a, _b, _c;

  this.log = function (functionName, args) {
    if (!_this.debug) return;

    _this.logger.groupCollapsed("%c".concat(_this.controller.identifier, " %c#").concat(functionName), 'color: #3B82F6', 'color: unset');

    _this.logger.log(Object.assign({
      controllerId: _this.controllerId
    }, args));

    _this.logger.groupEnd();
  };

  this.debug = (_b = (_a = options === null || options === void 0 ? void 0 : options.debug) !== null && _a !== void 0 ? _a : controller.application.stimulusUseDebug) !== null && _b !== void 0 ? _b : defaultOptions.debug;
  this.logger = (_c = options === null || options === void 0 ? void 0 : options.logger) !== null && _c !== void 0 ? _c : defaultOptions.logger;
  this.controller = controller;
  this.controllerId = controller.element.id || controller.element.dataset.id; // make copies of lifecycle functions

  this.controllerInitialize = controller.initialize.bind(controller);
  this.controllerConnect = controller.connect.bind(controller);
  this.controllerDisconnect = controller.disconnect.bind(controller);
});